import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
import LanguageSelector from '../components/LanguageSelector';

const Welcome = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    { key: 'problem', text: t('welcome.problem') },
    { key: 'solution', text: t('welcome.solution') },
    { key: 'tone', text: t('welcome.tone') }
  ];

  const handleNext = () => {
    if (currentSlide < slides.length - 1) {
      setCurrentSlide(currentSlide + 1);
    } else {
      navigate('/onboarding-v2');
    }
  };

  return (
    <div className="min-h-screen flex flex-col pb-safe bg-white relative">
      <LanguageSelector />
      <div className="flex-1 flex flex-col items-center justify-center px-6 pt-12">
        <div className="max-w-md mx-auto w-full">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentSlide}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -20 }}
              transition={{ duration: 0.35 }}
              className="flex flex-col items-center"
            >
              <p className="font-sans text-xl leading-relaxed whitespace-pre-line text-center font-medium text-stone-900">
                {slides[currentSlide].text}
              </p>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>

      <div className="p-6 max-w-md mx-auto w-full space-y-6">
        <div className="flex gap-2 justify-center">
          {slides.map((_, index) => (
            <div
              key={index}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                index === currentSlide ? 'w-8 bg-stone-900' : 'w-1.5 bg-stone-300'
              }`}
            />
          ))}
        </div>

        <button
          data-testid="welcome-continue-btn"
          onClick={handleNext}
          style={{
            width: '100%', height: 52,
            background: 'linear-gradient(to right, #90d960, #6DB33F)', color: '#0a0a0a', border: 'none', cursor: 'pointer',
            fontFamily: 'Manrope-Variable, Manrope, sans-serif',
            fontWeight: 600, fontSize: 15, borderRadius: 12,
            boxShadow: '0 0 20px rgba(144, 217, 96, 0.3)',
            transition: 'all 0.3s',
          }}
        >
          {currentSlide === slides.length - 1 ? t('welcome.continue') : <ChevronRight className="w-6 h-6" />}
        </button>
      </div>
    </div>
  );
};

export default Welcome;